import { ITranslationMap } from '@principle-theorem/practice-migrations/interfaces';
import { IStaffer } from '@principle-theorem/principle-core/interfaces';
import { Firestore, WithPrimaryKey, WithRef } from '@principle-theorem/shared';
import { STAFFER_RESOURCE_TYPE } from '../../../destination/entities/staff';
import { IBaseMigrationStaffer } from '../../../interfaces';
import { StafferMappingHandler } from '../../../mappings/staff';
import { TranslationMapHandler } from '../../../translation-map';
import {
  ExactStaffer,
  IExactStaffer,
  StafferSourceEntity,
} from '../../source/entities/staff';

export class ExactStafferMappingHandler extends StafferMappingHandler<
  ExactStaffer,
  StafferSourceEntity
> {
  override sourceEntity = new StafferSourceEntity();
  translateFn = (record: IExactStaffer): IBaseMigrationStaffer => {
    const name = record.name
      ? record.name
      : `${record.first_name} ${record.surname}`;
    return {
      id: record.id,
      name: name,
      providerNo: '',
    };
  };
}

export async function resolveExactStaffer(
  stafferInitials: string,
  translationMap: TranslationMapHandler,
  staff: WithPrimaryKey<ITranslationMap<IStaffer>>[]
): Promise<WithRef<IStaffer> | undefined> {
  const staffMapping = staff.find(
    (staffer) => staffer.sourceIdentifier === stafferInitials
  )?.destinationIdentifier;

  if (staffMapping) {
    return Firestore.getDoc(staffMapping);
  }

  const staffRef = await translationMap.getBySource<IStaffer>(
    stafferInitials,
    STAFFER_RESOURCE_TYPE
  );

  if (staffRef?.destinationIdentifier) {
    return Firestore.getDoc(staffRef.destinationIdentifier);
  }

  // Default provider is used from custom mapping with id: 0
  const defaultStaffer = staff.find(
    (staffer) => staffer.sourceIdentifier === '0'
  )?.destinationIdentifier;

  return defaultStaffer ? Firestore.getDoc(defaultStaffer) : undefined;
}
